import React from 'react';
import { Result } from 'antd';
import { useCompanyAdminScope } from './useCompanyAdminScope';

export interface CompanyAdminTarget {
  companyId: string;
  companyName: string;
  instanceId: string | null;
}

/**
 * Company administration pages operate on the header-selected company.
 * Missing selection is an empty state. A member without a manager role is refused.
 */
export const CompanyAdminGate: React.FC<{
  children: (target: CompanyAdminTarget) => React.ReactNode;
}> = ({ children }) => {
  const scope = useCompanyAdminScope();
  if (!scope.canManage) {
    return (
      <Result
        status="403"
        title="Company administrator access is required"
        subTitle="This page is limited to a company manager for the selected company, or a platform administrator."
      />
    );
  }
  if (!scope.companyId) {
    return (
      <Result
        status="info"
        title="Select a company"
        subTitle="Use the company picker in the header. Users, subscriptions, models, billing, and session schedules on these pages apply to that company only."
      />
    );
  }
  return (
    <>
      {children({
        companyId: scope.companyId,
        companyName: scope.companyName || scope.companyId,
        instanceId: scope.instanceId,
      })}
    </>
  );
};
